import { createSlice } from "@reduxjs/toolkit";
import profileInitialState from "@/components/ProfileSideDrawer/redux/initialState";
import ProfileReducer from "@/components/ProfileSideDrawer/redux/reducers";

const profileSlice = createSlice({
  name: "profile",
  initialState: profileInitialState,
  reducers: ProfileReducer,
});

export const { setLoading, setError, setIsProfileOpen, setIsOpenOnboardingSteps, setOnboardingJourneySteps } =
  profileSlice.actions;

export default profileSlice.reducer;
